document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantes();
  initMarquesina();
  initAnclas();
});

function initAnclas() {
  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-mt-scroll-btn]').forEach(function (boton) {
    var id = boton.getAttribute('data-mt-scroll-btn');
    if (!id) return;
    var destino = document.getElementById(id);
    if (!destino) return;
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var y = Math.round(destino.getBoundingClientRect().top + window.pageYOffset - 90);
      if (sinMovimiento) {
        window.scrollTo(0, y);
        return;
      }
      var inicio = window.pageYOffset;
      var distancia = y - inicio;
      var duracion = 650;
      var t0 = null;
      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
      function paso(ts) {
        if (!t0) t0 = ts;
        var progreso = Math.min((ts - t0) / duracion, 1);
        window.scrollTo(0, inicio + distancia * easeInOutCubic(progreso));
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      // Red de seguridad: si por lo que sea la animacion no corrio, forzamos el destino igual.
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - y) > 4) window.scrollTo(0, y);
      }, duracion + 150);
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  var groups = {};
  els.forEach(function (el) {
    var group = el.closest('[data-mt-reveal-group]');
    var key = group ? group : 'root';
    if (!groups[key]) groups[key] = 0;
    el.style.setProperty('--mt-stagger-i', groups[key]);
    groups[key]++;
  });
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si por lo que sea el observador no revela algo
  // (fallo de red, pestaña en segundo plano...), no dejamos contenido oculto.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 4000);
}

function initContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.dataset.fin || '0');
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)).toString();
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toString();
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var wraps = document.querySelectorAll('[data-mt-galeria]');
  wraps.forEach(function (wrap) {
    var principal = wrap.querySelector('[data-mt-galeria-principal]');
    var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.full;
        if (!src) return;
        principal.src = src;
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activo'); });
        thumb.classList.add('mt-thumb-activo');
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioCompareEl = form.querySelector('[data-mt-precio-comparado]');
    var descuentoEl = form.querySelector('[data-mt-descuento-pct]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    if (!selects.length || !idInput) return;

    function moneda(centavos) {
      return form.dataset.mtMonedaFormato
        ? form.dataset.mtMonedaFormato.replace('{{amount}}', (centavos / 100).toFixed(2))
        : (centavos / 100).toFixed(2);
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.hidden = false;
          if (descuentoEl) {
            var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
            descuentoEl.textContent = '-' + pct + '%';
            descuentoEl.hidden = false;
          }
        } else {
          precioCompareEl.hidden = true;
          if (descuentoEl) descuentoEl.hidden = true;
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.dataset.textoDisponible || botonEl.textContent;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.dataset.textoAgotado || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initMarquesina() {
  var els = document.querySelectorAll('[data-mt-marquesina-track]');
  els.forEach(function (track) {
    if (track.dataset.mtDuplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtDuplicado = '1';
  });
}
